import React from 'react';
import { Col, Form, Input, Row, TimePicker } from 'antd';
import { TIME_FORMAT } from '../../../constants';
import './DeliveryForm.scss';
import AddressInput from '../../Inputs/AddressInput';
import isEmpty from 'lodash/isEmpty';
import OptionalLabel from '../../Elements/OptionalLabel';

const DeliveryForm = ({ form, isReturn }) => {
  const prefixTitle = isReturn ? 'Pickup' : 'Delivery';
  const prefixKey = prefixTitle.toLocaleLowerCase();

  return (
    <div className={`DeliveryForm`}>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item label={`Name`} name={`${prefixKey}Name`} rules={[{ required: true, message: 'Required' }]}>
            <Input size="large" placeholder={`Name`} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={`Email`}
            name={`${prefixKey}Email`}
            rules={[
              { required: true, message: 'Required' },
              { type: 'email', message: 'Invalid Email' },
            ]}
          >
            <Input size="large" placeholder={`Email`} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={`Address`}
            name={`${prefixKey}Address`}
            rules={[
              {
                validator: (_, value) => {
                  if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                    return Promise.resolve();
                  }

                  if (isEmpty(value?.address)) {
                    return Promise.reject(new Error('Required'));
                  }

                  return Promise.reject(new Error('Invalid'));
                },
              },
            ]}
          >
            <AddressInput
              size="large"
              placeholder={`Address`}
              onSelect={(value) => form.setFieldsValue({ [`${prefixKey}Address`]: value })}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={`Phone Number`}
            name={`${prefixKey}Phone`}
            rules={[
              { required: true, message: 'Required' },
              {
                pattern: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
                message: 'Please enter a valid phone',
              },
            ]}
          >
            <Input size="large" placeholder={`Phone`} />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="dateRange" label={`Time Window`}>
            <TimePicker.RangePicker format={TIME_FORMAT} size="large" allowEmpty={[true, true]} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item name={`${prefixKey}Note`} label={<OptionalLabel title={`${prefixTitle} Note`} />}>
            <Input size="large" placeholder="Note" />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default DeliveryForm;
